import checkout from "./form5";

const {
  formField5: {
    taxpayerName,
    taxId,
    taxAgencyId,
    taxAgencyName,
  },
} = checkout;

const initialValues5 = {
  [taxId.name]: "",
  [taxpayerName.name]: "",
  [taxAgencyId.name]: "",
  [taxAgencyName.name]: "",
};

export default initialValues5;
